import React, {useState} from "react";
import {Box, Button, Column, Columns, Control, Input, Title} from "@allxsmith/bestax-bulma";


export default function CreatePaymentType({onSave}){
    const [typeName, setTypeName] = useState("")

    return (
        <Box>
            <details>
                <summary><Title>Add Payment Type</Title></summary>
            <Columns isMultiline>
                <Column>
                    <Control>
                        <label className="label">Name</label>
                        <Input
                            type={"text"}
                            value={typeName}
                            onChange={(e) => setTypeName(e.target.value)}
                        />
                    </Control>
                </Column>
                <Column/>
                <Column/>
                <Column/>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <Button
                        color={"success"}
                        onClick={()=>{
                            onSave({name: typeName});
                            setTypeName("");
                        }}
                        isFullWidth
                    >
                        Create
                    </Button>
                </Column>
            </Columns>
            </details>
        </Box>
    );


}